import React from 'react';
import clsx from 'clsx';
import { RadioButtonOn, RadioButtonOff } from '@rakutenfrance/material-ui-icons';
import { withStyles } from '@material-ui/core';
export const styles = (theme) => ({
    root: {
        position: 'relative',
        display: 'flex',
        '&$checked $layer': {
            transform: 'scale(1)',
            transition: theme.transitions.create('transform', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.shortest,
            }),
        },
    },
    layer: {
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest,
        }),
    },
    checked: {},
});
/**
 * @ignore - internal component.
 */
function RadioButtonIcon(props) {
    const { checked, classes } = props;
    return (React.createElement("div", { className: clsx(classes.root, { [classes.checked]: checked }) },
        React.createElement(RadioButtonOff, { style: { fontSize: 16 } }),
        React.createElement(RadioButtonOn, { style: { fontSize: 16 }, className: classes.layer })));
}
export default withStyles(styles, { name: 'PrivateRadioButtonIcon' })(RadioButtonIcon);
